<template>
  <div>
    <h1 class="h3">Last Step</h1>
    <b-row>
      <b-col md="8" lg="4">
        <ValidationProvider rules="required" name="enthusiast-type">
          <b-form-group
            id="select-group-type"
            label="What type of Enthusiast are you?*"
            label-for="select-type"
          >
            <b-form-select
              id="select-type"
              class="btn-double-outline btn-double-outline--normal"
              required
              v-model="selected_type"
              :options="options">
            </b-form-select>
          </b-form-group>
        </ValidationProvider>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="8" lg="4">
        <b-form-group
          label="Anything else you’d like to share?"
          label-for="textarea-info"
          class="mt-md-5"
        >
          <b-form-textarea
            id="textarea-info"
            class="btn-double-outline btn-double-outline--normal"
            v-model="additional_info"
          ></b-form-textarea>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'EnthusiastType',
  data() {
    return {
      options: [
        { value: null, text: 'Select One', disabled: true },
        { text: 'Time Attack', value: 'Time Attack' },
        { text: 'Drift', value: 'Drift' },
        { text: 'Drag Race', value: 'Drag Race' },
        { text: 'Off-Road', value: 'Off-Road' },
        { text: 'Overland', value: 'Overland' },
        { text: 'Truck (gas)', value: 'Truck (gas)' },
        { text: 'Truck (diesel)', value: 'Truck (diesel)' },
        { text: 'Show', value: 'Show' },
      ],
    };
  },
  watch: {
    selected_type(newVal, oldVal) {
      if (newVal !== oldVal && newVal !== '') {
        this.validateStep();
      }
    },
  },
  computed: {
    additional_info: {
      get() {
        return this.$store.state.AdditionalInfo;
      },
      set(value) {
        this.$store.dispatch('additionalInfo', value);
      },
    },
    selected_type: {
      get() {
        return this.$store.state.EnthusiastType;
      },
      set(value) {
        this.$store.dispatch('enthusiastType', value);
      },
    },
  },
  methods: {
    validateStep() {
      this.$nextTick(() => this.$emit('onValidate', null));
    },
  },
};
</script>

<style lang="scss" scoped>
h1 {
  margin-bottom: 40px;
}
</style>
